import { DistributionLandingComponent } from './distribution-landing.component';

export const containers: any[] = [
	DistributionLandingComponent
];

export * from './distribution-landing.component';
